'use client';
import React from 'react';
import { useRouter } from 'next/navigation';

export default function Custom500() {
  const router = useRouter();
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 px-6">
      <div className="text-center">
        <h1 className="text-7xl font-extrabold text-red-500 drop-shadow-sm">500</h1>
        <h2 className="text-2xl font-semibold mt-4 text-gray-800">Lỗi máy chủ</h2>
        <p className="text-gray-600 mt-2 max-w-md mx-auto">
          Xin lỗi! Có lỗi xảy ra từ phía máy chủ. Vui lòng thử lại sau hoặc quay về trang
          chủ.
        </p>
        <div className="mt-6 flex justify-center gap-4">
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition"
          >
            Thử lại
          </button>
          <button
            onClick={() => router.push('/')}
            className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400 transition"
          >
            Trang chủ
          </button>
        </div>
      </div>
    </div>
  );
}
